import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Dropdown, Breadcrumb, Col } from "react-bootstrap";
import { FaList, FaTh, FaPlus } from "react-icons/fa";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import AddTicketModal from "../../modals/hrm/tickets/AddTicketModa";


const TicketsHeader = ({ openModal,tittle }) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">

   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Tickets</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
             Tickets
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">{tittle}</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      <div className="d-flex align-items-center flex-wrap">

        {/* VIEW TOGGLE */}
        <div className="d-flex me-3 border p-1 rounded mb-2">

          <Link
            to="/tickets-list"
            className={`btn btn-icon btn-sm me-1 ${
              location.pathname === "/tickets-list" ? "active-view" : ""
            }`}
          >
            <FaList />
          </Link>

          <Link
            to="/tickets-grid"
            className={`btn btn-icon btn-sm ${
              location.pathname === "/tickets-grid" ? "active-view" : ""
            }`}
          >
            <FaTh />
          </Link>
        </div>

        <Dropdown className="me-2 mb-2 border">
          <Dropdown.Toggle variant="light">Export</Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>PDF</Dropdown.Item>
            <Dropdown.Item>Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      <Button
        className="mb-2"
        onClick={() => setShowModal(true)}
        style={{ background: "#ff6b00", border: "none" }}
      >
        <FaPlus className="me-2" /> Add Ticket
      </Button>
      </div>
    {/* MODAL */}
      <AddTicketModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
      {/* INLINE CSS */}
      <style>
        {`
        .btn-icon {
          background: #fff;
          border: 1px solid #e5e7eb;
          color: #6b7280;
        }

        .btn-icon:hover {
          background: #fff7ed;
          color: #ff6b00;
          border-color: #ff6b00;
        }

        .active-view {
          background-color: #ff6b00 !important;
          color: #fff !important;
          border-color: #ff6b00 !important;
        }
      `}
      </style>
    </div>
  );
};

export default TicketsHeader;